module.exports = __webpack_public_path__ + "static/media/img-home.1c75bc75.jpg";